/* global axios */
import ApiClient from './ApiClient';

class FunnelAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  getCards(funnelId) {
    return axios.get(`${this.url}/${funnelId}/funnel_cards`);
  }

  createCard(funnelId, data) {
    return axios.post(`${this.url}/${funnelId}/funnel_cards`, data);
  }

  updateCard(funnelId, cardId, data) {
    return axios.patch(`${this.url}/${funnelId}/funnel_cards/${cardId}`, data);
  }

  deleteCard(funnelId, cardId) {
    return axios.delete(`${this.url}/${funnelId}/funnel_cards/${cardId}`);
  }

  showCard(funnelId, cardId) {
    return axios.get(`${this.url}/${funnelId}/funnel_cards/${cardId}`);
  }

  moveCard(funnelId, cardId, data) {
    return axios.patch(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/move`,
      data
    );
  }

  markCardWon(funnelId, cardId) {
    return axios.patch(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/mark_won`
    );
  }

  markCardLost(funnelId, cardId, lossReason) {
    return axios.patch(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/mark_lost`,
      { loss_reason: lossReason }
    );
  }

  migrateCard(funnelId, cardId, { targetFunnelId, targetStageId }) {
    return axios.post(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/migrate`,
      { target_funnel_id: targetFunnelId, target_stage_id: targetStageId }
    );
  }

  attachMessageAttachments(funnelId, cardId, messageId, documentName) {
    return axios.post(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/attach_message_attachments`,
      { message_id: messageId, document_name: documentName }
    );
  }

  // Junta os arquivos do card num único PDF no servidor (poppler + ImageMagick).
  // activityIds (opcional) limita a fusão aos arquivos escolhidos no modal.
  // Retorna o PDF como blob para download no navegador.
  mergeFilesToPdf(funnelId, cardId, activityIds = []) {
    return axios.get(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/merge_files_pdf`,
      { responseType: 'blob', params: { activity_ids: activityIds } }
    );
  }

  getActivities(funnelId, cardId) {
    return axios.get(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/funnel_card_activities`
    );
  }

  createActivity(funnelId, cardId, data) {
    return axios.post(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/funnel_card_activities`,
      data
    );
  }

  updateActivity(funnelId, cardId, activityId, data) {
    return axios.patch(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/funnel_card_activities/${activityId}`,
      { funnel_card_activity: data }
    );
  }

  deleteActivity(funnelId, cardId, activityId) {
    return axios.delete(
      `${this.url}/${funnelId}/funnel_cards/${cardId}/funnel_card_activities/${activityId}`
    );
  }

  getStages(funnelId) {
    return axios.get(`${this.url}/${funnelId}/funnel_stages`);
  }

  createStage(funnelId, data) {
    return axios.post(`${this.url}/${funnelId}/funnel_stages`, data);
  }

  updateStage(funnelId, stageId, data) {
    return axios.patch(
      `${this.url}/${funnelId}/funnel_stages/${stageId}`,
      data
    );
  }

  deleteStage(funnelId, stageId) {
    return axios.delete(`${this.url}/${funnelId}/funnel_stages/${stageId}`);
  }

  getPermissions(funnelId) {
    return axios.get(`${this.url}/${funnelId}/funnel_permissions`);
  }

  createPermission(funnelId, data) {
    return axios.post(`${this.url}/${funnelId}/funnel_permissions`, data);
  }

  updatePermission(funnelId, permissionId, data) {
    return axios.patch(
      `${this.url}/${funnelId}/funnel_permissions/${permissionId}`,
      data
    );
  }

  deletePermission(funnelId, permissionId) {
    return axios.delete(
      `${this.url}/${funnelId}/funnel_permissions/${permissionId}`
    );
  }
}

export default new FunnelAPI();
